import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-loading-filters',
  templateUrl: './loading-filters.component.html',
  styleUrls: ['./loading-filters.component.css']
})
export class LoadingFiltersComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
